exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "work-team-list .month-list{height:37px;border-bottom:1px solid #f0f3f8;padding-top:2px}work-team-list .months{font-family:Stag Sans;font-size:16px;font-weight:400;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;text-align:center;color:#121212}work-team-list .col0{margin-left:-3%}work-team-list .col1,work-team-list .col2{margin-left:4%}work-team-list .col3{margin-left:3%}work-team-list .list-empty{margin-top:0;padding-top:40px;padding-bottom:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9;background-color:#fff}work-team-list .list-empty.shown-filter{margin-top:0}work-team-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}work-team-list .responsiveMobile .col0{margin-left:-28px}work-team-list .responsiveMobile .col1,work-team-list .responsiveMobile .col2,work-team-list .responsiveMobile .col3{margin-left:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/food-benefit.module/components/workTeamList/workTeamList.scss
// module id = 1735
// module chunks = 0